import React, { useEffect, useRef, useState } from "react";

/* ─────────────────────────────────────────────
   SVG ICONS
───────────────────────────────────────────── */
const IconShield = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#FFD700" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
  </svg>
);
const IconSearch = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#FFD700" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" />
  </svg>
);
const IconWrench = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#FFD700" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" />
  </svg>
);
const IconTruck = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#FFD700" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="1" y="3" width="15" height="13" rx="1" />
    <path d="M16 8h4l3 3v5h-7V8z" />
    <circle cx="5.5" cy="18.5" r="2.5" /><circle cx="18.5" cy="18.5" r="2.5" />
  </svg>
);
const IconCar = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#FFD700" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M5 17H3a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h13l4 4v6a2 2 0 0 1-2 2h-2" />
    <circle cx="7.5" cy="17.5" r="2.5" /><circle cx="17.5" cy="17.5" r="2.5" />
  </svg>
);
const IconStar = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="#FFD700" stroke="#FFD700" strokeWidth="1.5">
    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
  </svg>
);
const IconCheck = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#FFD700" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="20 6 9 17 4 12" />
  </svg>
);
const IconClock = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#FFD700" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" />
  </svg>
);
const IconPhone = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.61 3.4 2 2 0 0 1 3.58 1.2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L7.91 8.96a16 16 0 0 0 6.13 6.13l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
  </svg>
);
const IconWhatsapp = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51a12.8 12.8 0 0 0-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413Z" />
  </svg>
);
const IconMapPin = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#FFD700" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
    <circle cx="12" cy="10" r="3" />
  </svg>
);
const IconQuote = () => (
  <svg width="36" height="36" viewBox="0 0 24 24" fill="#FFD700" opacity="0.18">
    <path d="M3 21c3 0 7-1 7-8V5c0-1.25-.756-2.017-2-2H4c-1.25 0-2 .75-2 1.972V11c0 1.25.75 2 2 2 1 0 1 0 1 1v1c0 1-1 2-2 2s-1 .008-1 1.031V20c0 1 0 1 1 1z" />
    <path d="M15 21c3 0 7-1 7-8V5c0-1.25-.757-2.017-2-2h-4c-1.25 0-2 .75-2 1.972V11c0 1.25.75 2 2 2h.75c0 2.25.25 4-2.75 4v3c0 1 0 1 1 1z" />
  </svg>
);
const IconTeam = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#FFD700" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
  </svg>
);
const IconFinance = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#FFD700" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="12" y1="1" x2="12" y2="23" />
    <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
  </svg>
);
const IconUser = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#555" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
    <circle cx="12" cy="7" r="4" />
  </svg>
);
const IconChevronLeft = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="15 18 9 12 15 6" />
  </svg>
);
const IconChevronRight = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="9 18 15 12 9 6" />
  </svg>
);

/* ─────────────────────────────────────────────
   REVIEWS DATA — add photo URLs when ready
───────────────────────────────────────────── */
const REVIEWS = [
  {
    name: "ArijitSingh Khushwah",
    role: "Proud Hyundai i20",
    photo: "", // replace with: "/images/rahul.jpg" or full URL
    text: `One of the best places to buy certified pre-owned cars with warranty`,
    rating: 5,
  },
  {
    name: "Dr. Rahul Pethe",
    role: "Proud Alto 800 Owner",
    photo: "",
    text: `
    It was nice experience with all the staff members.
    I personally recommend such valuable customer service support.
    Recommend to all those who want to purchase second had cars.
    Blindly follow and purchase as a new family members.
    Thank you once again    
    `,
    rating: 4.5,
  },
  {
    name: "Tarul Jayant Raut",
    role: "Proud Hyndai Aura Owner",
    photo: "",
    text: `Outstanding Service and Quality Car - PRG Cars Delivers!
    I highly recommend PRG Cars for their friendly approach, quality vehicles, and
     commitment to customer satisfaction.`,
    rating: 5,
  },
  {
    name: "Priya Deshmukh",
    role: "Maruti Baleno Owner",
    photo: "",
    text: "The 120-point inspection gave me so much confidence. I drove away feeling totally secure in my purchase. Will definitely refer friends!",
    rating: 5,
  }
];

/* ─────────────────────────────────────────────
   INFINITE CAROUSEL — responsive card width
───────────────────────────────────────────── */
function TestimonialCarousel() {
  const total = REVIEWS.length;
  // Clone-sandwich for seamless infinite loop
  const slides = [REVIEWS[total - 1], ...REVIEWS, REVIEWS[0]];

  const [idx, setIdx] = useState(1);
  const [animated, setAnimated] = useState(true);
  const [paused, setPaused] = useState(false);
  const timerRef = useRef<ReturnType<typeof setInterval> | null>(null);

  const goTo = (next: number, anim = true) => { setAnimated(anim); setIdx(next); };
  const next = () => goTo(idx + 1);
  const prev = () => goTo(idx - 1);

  const onTransitionEnd = () => {
    if (idx === 0) goTo(total, false);
    else if (idx === slides.length - 1) goTo(1, false);
  };

  useEffect(() => {
    if (!paused) timerRef.current = setInterval(next, 3400);
    return () => { if (timerRef.current) clearInterval(timerRef.current); };
  }, [idx, paused]);

  const dotIdx = idx === 0 ? total - 1 : idx === slides.length - 1 ? 0 : idx - 1;

  // CSS custom-property trick: cards are sized 100% on mobile via CSS class,
  // fixed 380px on desktop — no JS measurement needed, no layout flash.
  return (
    <div className="tc-root">
      <style>{`
        .tc-root { width: 100%; }

        /* The overflow-hidden viewport */
        .tc-viewport { overflow: hidden; position: relative; width: 100%; }

        /* Edge fades — visible only on desktop */
        .tc-fade-l, .tc-fade-r {
          position: absolute; top: 0; bottom: 0; width: 56px;
          z-index: 2; pointer-events: none;
        }
        .tc-fade-l { left: 0;  background: linear-gradient(to right, #0a0a0a, transparent); }
        .tc-fade-r { right: 0; background: linear-gradient(to left,  #0a0a0a, transparent); }

        /* Sliding track */
        .tc-track {
          display: flex;
          /* gap matches --tc-gap below */
          gap: var(--tc-gap, 16px);
          will-change: transform;

        }

        /* Each card */
        .tc-card {
          flex-shrink: 0;
          /* Full width on mobile, fixed on desktop */
          width: 100%;
          background: #111;
          border-radius: 18px;
          padding: 26px 20px 22px;
          border: 1px solid #222;
          position: relative;
          box-sizing: border-box;
          text-align: justify
        }

        /* Desktop overrides */
        @media (min-width: 641px) {
          .tc-card      { width: 360px; }
          .tc-fade-l,
          .tc-fade-r    { display: block; }
        }
        @media (max-width: 640px) {
          .tc-fade-l,
          .tc-fade-r    { display: none; }
        }
      `}</style>

      <div
        className="tc-viewport"
        onMouseEnter={() => setPaused(true)}
        onMouseLeave={() => setPaused(false)}
        onTouchStart={() => setPaused(true)}
        onTouchEnd={() => setPaused(false)}
      >
        <div className="tc-fade-l" />
        <div className="tc-fade-r" />

        {/* We compute translateX in JS using the rendered card width.
            Because .tc-card width is CSS-driven (100% or 360px), we read it
            via a ref only to know STEP. We keep a measured state for this. */}
        <_TrackInner
          slides={slides}
          idx={idx}
          animated={animated}
          onTransitionEnd={onTransitionEnd}
        />
      </div>

      {/* Controls */}
      <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 16, marginTop: 26 }}>
        <button onClick={prev} style={navBtn}><IconChevronLeft /></button>
        <div style={{ display: "flex", gap: 7, alignItems: "center" }}>
          {REVIEWS.map((_, i) => (
            <button key={i} onClick={() => goTo(i + 1)} style={{
              width: dotIdx === i ? 22 : 8, height: 8, borderRadius: 999,
              background: dotIdx === i ? "#FFD700" : "#2e2e2e",
              border: "none", cursor: "pointer", padding: 0,
              textAlign:'justify',
              transition: "width 0.3s ease, background 0.3s ease",
            }} />
          ))}
        </div>
        <button onClick={next} style={navBtn}><IconChevronRight /></button>
      </div>
    </div>
  );
}

/* Inner track: measures first card width then drives translateX */
function _TrackInner({ slides, idx, animated, onTransitionEnd }: {
  slides: typeof REVIEWS;
  idx: number;
  animated: boolean;
  onTransitionEnd: () => void;
}) {
  const trackRef = useRef<HTMLDivElement>(null);
  const [step, setStep] = useState(0);
  const GAP = 16;

  useEffect(() => {
    const measure = () => {
      const firstCard = trackRef.current?.querySelector(".tc-card") as HTMLElement | null;
      if (firstCard) setStep(firstCard.offsetWidth + GAP);
    };
    measure();
    const ro = new ResizeObserver(measure);
    if (trackRef.current) ro.observe(trackRef.current);
    return () => ro.disconnect();
  }, []);

  return (
    <div
      ref={trackRef}
      className="tc-track"
      style={{
        transform: step ? `translateX(${-idx * step}px)` : undefined,
        transition: animated && step ? "transform 0.5s cubic-bezier(0.4,0,0.2,1)" : "none",
        textAlign:'justify',
      }}
      onTransitionEnd={onTransitionEnd}
    >
      {slides.map((r, i) => (
        <div key={i} className="tc-card">
          {/* Quote decoration */}
          <div style={{ position: "absolute" as const, top: 18, right: 18 }}>
            <IconQuote />
          </div>

          {/* Stars */}
          <div style={{ display: "flex", gap: 3, marginBottom: 12 }}>
            {Array.from({ length: r.rating }).map((_, si) => (
              <svg key={si} width="14" height="14" viewBox="0 0 24 24" fill="#FFD700">
                <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
              </svg>
            ))}
          </div>

          {/* Review text */}
          <p style={{ color: "#ccc", fontSize: 14, lineHeight: 1.78, margin: "0 0 20px" }}>
            "{r.text}"
          </p>

          {/* Author row */}
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            {/* Photo / avatar */}
            <div style={{
              width: 50, height: 50, borderRadius: "50%",
              overflow: "hidden", flexShrink: 0,
              border: "2px solid #2a2a2a", background: "#181818",
              display: "flex", alignItems: "center", justifyContent: "center",
              position: "relative" as const,
            }}>
              {r.photo ? (
                <img src={r.photo} alt={r.name} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
              ) : (
                <>
                  <IconUser />
                  <span style={{ position: "absolute" as const, fontSize: 13, fontWeight: 800, color: "#FFD700" }}>
                    {r.name.split(" ").map((w: string) => w[0]).join("")}
                  </span>
                </>
              )}
            </div>

            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontWeight: 700, fontSize: 14, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" as const }}>{r.name}</div>
              <div style={{ color: "#666", fontSize: 12, marginTop: 2 }}>{r.role}</div>
            </div>

            {/* Verified badge */}
            <div style={{ display: "flex", alignItems: "center", gap: 4, background: "#0d1f0d", border: "1px solid #1e3e1e", borderRadius: 999, padding: "4px 10px", flexShrink: 0 }}>
              <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="#4ade80" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="20 6 9 17 4 12" />
              </svg>
              <span style={{ fontSize: 10, color: "#4ade80", fontWeight: 600 }}>Verified</span>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

const navBtn: React.CSSProperties = {
  width: 40, height: 40, borderRadius: "50%",
  background: "#161616", border: "1px solid #2e2e2e",
  color: "#fff", cursor: "pointer",
  display: "flex", alignItems: "center", justifyContent: "center",
  flexShrink: 0,
};

/* ─────────────────────────────────────────────
   MAIN PAGE
───────────────────────────────────────────── */
export default function AboutUs() {
  return (
    <div style={{ background: "#0a0a0a", color: "#fff", fontFamily: "'Segoe UI', system-ui" }}>

      {/* ── HERO ── */}
      <section style={heroSection}>
        <div className="hero-wrap" style={heroContainer}>

          {/* Gallery wrapper — float on desktop, static grid on mobile */}
          <div className="hero-gallery-wrapper">

  {/* GRID GALLERY (works for all screens) */}
  <div
        style={{
          flex: "1 1 400px",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <img
          src="prgcustomer.png"
          alt="Luxury Car"
          style={{
            width: "100%",
            maxWidth: "500px",
            borderRadius: "16px",
            boxShadow: "0 20px 50px rgba(0,0,0,0.5)",
            objectFit: "cover",
          }}
        />
      </div>
</div>
          



          {/* Hero text */}
          <div className="hero-text" style={heroText}>
            <div style={badgePill}>
              <IconCar />
              <span style={{ marginLeft: 8, fontSize: 13, fontWeight: 600, letterSpacing: 1, textTransform: "uppercase" as const }}>
                Nagpur's Trusted 
              </span>
            </div>
            <h1 style={heroTitle}>
              Driven by Trust.<br />
              Powered by <span style={{ color: "#FFD700" }}>Quality</span>
            </h1>
            <p style={heroDesc}>
              Premium pre-owned cars with transparency, quality, and unmatched customer experience.
            </p>
            <div style={{ display: "flex", gap: 12, flexWrap: "wrap" as const, marginTop: 24 }}>
              <a href="/#featured-cars" style={ctaBtn}>Browse Cars</a>
              <a href="https://wa.me/919766624663" target="_blank" rel="noopener noreferrer"
                style={{ ...ctaBtn, background: "transparent", border: "1.5px solid #FFD700", color: "#FFD700" }}>
                <IconWhatsapp /> Chat with Us
              </a>
            </div>
          </div>
        </div>
      </section>

                      {/* ── TESTIMONIALS ── */}
            <section style={section}>
                <div style={container}>
                <span style={sectionLabel}>Customer Love</span>
                <h2 style={title}>What Customers Say</h2>
                <TestimonialCarousel />
                </div>
            </section>

      {/* ── ABOUT ── */}
      <section
  style={{
    padding: "80px 20px",
    background: "#0a0a0a",
  }}
>
  <div
    style={{
      maxWidth: "1200px",
      margin: "auto",
    }}
  >
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "40px",
        flexWrap: "wrap",
      }}
    >

      {/* LEFT - TEXT */}
      <div style={{ flex: "1 1 500px" }}>
        <span
          style={{
            color: "#FFD700",
            fontSize: "14px",
            letterSpacing: "1px",
          }}
        >
          Who We Are
        </span>

        <h2
          style={{
            color: "#fff",
            fontSize: "36px",
            margin: "10px 0",
          }}
        >
          About PRG Cars
        </h2>

        <p
          style={{
            color: "#aaa",
            textAlign:"justify"
          }}
        >
        


PRG Cars Pvt. Ltd. – Trusted Used Car Dealer in Nagpur

PRG Cars Pvt. Ltd. is a trusted name for certified used cars in Nagpur, offering a carefully curated selection of high-quality pre-owned vehicles. Every car undergoes a comprehensive inspection process to ensure it meets our standards of reliability, safety, and performance.

We are committed to delivering a transparent and hassle-free car buying experience, with complete assistance in documentation and ownership transfer. With a strong focus on trust, quality, and customer satisfaction, PRG Cars Pvt. Ltd. ensures a smooth and confident journey for every customer.


        </p>
      </div>

      {/* RIGHT - IMAGE */}
      <div
        style={{
          flex: "1 1 400px",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <img
          src="aboutprg1.png"
          alt="Luxury Car"
          style={{
            width: "100%",
            maxWidth: "500px",
            borderRadius: "16px",
            boxShadow: "0 20px 50px rgba(0,0,0,0.5)",
            objectFit: "cover",
          }}
        />
      </div>

    </div>
  </div>
</section>

      {/* ── STATS ── */}
      <section style={sectionAlt}>
        <div style={container}>
          <div className="stats-grid" style={statsGrid}>
            <StatCard icon={<IconCar />} number="500+" label="Cars Sold" />
            <StatCard icon={<IconStar />} number="4.8★" label="Customer Rating" />
            <StatCard icon={<IconCheck />} number="100%" label="Verified Vehicles" />
            <StatCard icon={<IconClock />} number="7+" label="Years Experience" />
          </div>
        </div>
      </section>

      {/* ── WHY US ── */}
      <section style={section}>
        <div style={container}>
          <span style={sectionLabel}>Why Choose Us</span>
          <h2 style={title}>The PRG Advantage</h2>
          <div className="feature-grid" style={featureGrid}>
            <FeatureCard icon={<IconShield />} title="Certified & Safe" desc="Every car passes our rigorous 120-point inspection before listing." />
            <FeatureCard icon={<IconCheck />} title="No Hidden Costs" desc="Transparent pricing with zero surprises at the time of purchase." />
            <FeatureCard icon={<IconTeam />} title="Expert Guidance" desc="Our team helps you find the right car for your budget and lifestyle." />
            <FeatureCard icon={<IconQuote />} title="Easy Finance" desc="Hassle-free loan assistance with leading banks and NBFCs." />
          </div>
        </div>
      </section>

      {/* ── PROCESS ── */}
      <section style={sectionAlt}>
        <div style={container}>
          <span style={sectionLabel}>How It Works</span>
          <h2 style={title}>Our Process</h2>
          <div className="process-steps" style={processGrid}>
            <ProcessStep step="01" icon={<IconSearch />} title="Inspection" desc="120-point mechanical & cosmetic inspection on every vehicle."  />
            <ProcessStep step="02" icon={<IconShield />} title="Verification" desc="Full document check, ownership history & RC verification." />
            <ProcessStep step="03" icon={<IconWrench />} title="Preparation" desc="Professional detailing, servicing, and any required repairs." />
            <ProcessStep step="04" icon={<IconTruck />} title="Delivery" desc="Smooth, hassle-free handover with all paperwork done for you." />
          </div>
        </div>
      </section>
      





      {/* ── MAP ── */}
      <section style={sectionAlt}>
        <div style={container}>
          <span style={sectionLabel}>Find Us</span>
          <h2 style={title}>
            <span style={{ display: "inline-flex", alignItems: "center", gap: 10 }}>
              <IconMapPin /> Visit Our Showroom
            </span>
          </h2>
          <p style={{ color: "#aaa", marginBottom: 20 }}>Manish Nagar, Nagpur, Maharashtra</p>
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4352.719189112876!2d79.08022487587748!3d21.088919680575522!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bd4c1709f130d87%3A0x3a962723a2a13579!2sPRG%20Cars!5e1!3m2!1sen!2sin!4v1777178191726!5m2!1sen!2sin"
            style={map}
            title="PRG Cars Location"
          />
          <div style={{ marginTop: 20, display: "flex", gap: 16, flexWrap: "wrap" as const }}>
            <a href="tel:+919766624663" style={contactChip}><IconPhone /> +91 97666 24663</a>
            <a href="https://wa.me/919766624663" target="_blank" rel="noopener noreferrer"
              style={{ ...contactChip, borderColor: "#25D366", color: "#25D366" }}>
              <IconWhatsapp /> WhatsApp Us
            </a>
          </div>
        </div>
      </section>

      {/* ── CTA ── */}
      <section style={ctaSection}>
        <div style={{ maxWidth: 600, margin: "0 auto" }}>
          <IconCar />
          <h2 style={{ fontSize: "clamp(22px, 5vw, 32px)", margin: "16px 0 8px" }}>Ready to Find Your Perfect Car?</h2>
          <p style={{ color: "#aaa", marginBottom: 28 }}>Browse our curated inventory of verified pre-owned vehicles in Nagpur.</p>
          <div style={{ display: "flex", gap: 12, justifyContent: "center", flexWrap: "wrap" as const }}>
            <a href="/#featured-cars" style={btnPrimary}>Browse Cars</a>
            <a href="https://wa.me/919766624663" target="_blank" rel="noopener noreferrer"
              style={{ ...btnPrimary, background: "transparent", border: "1.5px solid #FFD700", color: "#FFD700" }}>
              <IconWhatsapp /> WhatsApp Us
            </a>
          </div>
        </div>
      </section>

      {/* ── GLOBAL CSS ── */}
      <style>{`
        *, *::before, *::after { box-sizing: border-box; }
        body { font-family: 'Outfit', 'Segoe UI', sans-serif; }

        @keyframes float1 { 0%,100%{transform:translateY(0)} 50%{transform:translateY(-18px)} }
        @keyframes float2 { 0%,100%{transform:translateY(0)} 50%{transform:translateY(22px)} }

        /* HERO */
        .hero-wrap { flex-direction: row !important; }
        .hero-gallery-wrapper { flex: 1; min-width: 280px; }
        .hero-gallery-float  { display: block; }
        .hero-gallery-static { display: none; }

        @media (max-width: 768px) {
          .hero-wrap { flex-direction: column !important; text-align: center; }
          .hero-text  { align-items: center !important; }
          .hero-gallery-wrapper { width: 100%; min-width: unset; }
          .hero-gallery-float  { display: none !important; }
          .hero-gallery-static {
            display: grid !important;
            grid-template-columns: 1fr 1fr;
            gap: 10px;
            width: 100%;
          }
        }

        /* STATS */
        .stats-grid { grid-template-columns: repeat(4,1fr) !important; }
        @media(max-width:640px){ .stats-grid{ grid-template-columns:repeat(2,1fr)!important; } }

        /* FEATURES */
        .feature-grid { grid-template-columns: repeat(4,1fr) !important; }
        @media(max-width:900px){ .feature-grid{ grid-template-columns:repeat(2,1fr)!important; } }
        @media(max-width:480px){ .feature-grid{ grid-template-columns:1fr!important; } }

        /* PROCESS */
        .process-steps { grid-template-columns: repeat(4,1fr) !important; }
        @media(max-width:900px){ .process-steps{ grid-template-columns:repeat(2,1fr)!important; } }
        @media(max-width:480px){ .process-steps{ grid-template-columns:1fr!important; } }
      `}</style>
    </div>
  );
}

/* ─────────────────────────────────────────────
   HELPER COMPONENTS
───────────────────────────────────────────── */
const StatCard = ({ icon, number, label }: { icon: React.ReactNode; number: string; label: string }) => (
  <div style={{ background: "#111", borderRadius: 14, padding: "24px 16px", textAlign: "center" as const, border: "1px solid #222" }}>
    <div style={{ marginBottom: 10 }}>{icon}</div>
    <div style={{ fontSize: 28, fontWeight: 800, color: "#FFD700" }}>{number}</div>
    <div style={{ color: "#888", fontSize: 13, marginTop: 4 }}>{label}</div>
  </div>
);

const FeatureCard = ({ icon, title, desc }: { icon: React.ReactNode; title: string; desc: string }) => (
  <div
    style={{ background: "#111", borderRadius: 14, padding: "24px 20px", border: "1px solid #222", transition: "border-color 0.2s" }}
    onMouseEnter={e => (e.currentTarget.style.borderColor = "#FFD700")}
    onMouseLeave={e => (e.currentTarget.style.borderColor = "#222")}
  >
    <div style={{ marginBottom: 14 }}>{icon}</div>
    <h4 style={{ margin: "0 0 8px", fontSize: 16, fontWeight: 700 }}>{title}</h4>
    <p style={{ color: "#888", fontSize: 14, margin: 0, lineHeight: 1.6 }}>{desc}</p>
  </div>
);

const ProcessStep = ({ step, icon, title, desc }: { step: string; icon: React.ReactNode; title: string; desc: string }) => (
  <div style={{ background: "#161616", borderRadius: 14, padding: "24px 20px", border: "1px solid #222", position: "relative" as const, overflow: "hidden" as const }}>
    <div style={{ position: "absolute" as const, top: 12, right: 16, fontSize: 42, fontWeight: 900, color: "#FFD700", opacity: 0.06, lineHeight: 1 }}>{step}</div>
    <div style={{ marginBottom: 14 }}>{icon}</div>
    <h4 style={{ margin: "0 0 8px", fontSize: 16, fontWeight: 700 }}>{title}</h4>
    <p style={{ color: "#888", fontSize: 14, margin: 0, lineHeight: 1.6 }}>{desc}</p>
  </div>
);

/* ─────────────────────────────────────────────
   STYLES
───────────────────────────────────────────── */
const heroSection: React.CSSProperties = { padding: "60px 20px 40px" };
const heroContainer: React.CSSProperties = { maxWidth: 1200, margin: "0 auto", display: "flex", gap: 48, alignItems: "center", justifyContent: "space-between" };
const gallery: React.CSSProperties = { position: "relative", height: 420, minWidth: 280 };
const imgWrap: React.CSSProperties = { position: "absolute", borderRadius: 16, overflow: "hidden", boxShadow: "0 20px 50px rgba(0,0,0,0.5)" };
const imgStyle: React.CSSProperties = { width: "100%", height: "100%", objectFit: "cover" };
const img1: React.CSSProperties = { top: 0, left: "10%", width: 200, height: 250, animation: "float1 6s ease-in-out infinite" };
const img2: React.CSSProperties = { top: "20%", right: 0, width: 240, height: 180, animation: "float2 7s ease-in-out infinite" };
const img3: React.CSSProperties = { bottom: 0, left: 0, width: 200, height: 220, animation: "float2 8s ease-in-out infinite" };
const img4: React.CSSProperties = { bottom: "10%", right: "10%", width: 220, height: 240, animation: "float1 7s ease-in-out infinite" };
const heroText: React.CSSProperties = { flex: 1, maxWidth: 500, display: "flex", flexDirection: "column" };
const badgePill: React.CSSProperties = { display: "inline-flex", alignItems: "center", background: "#1a1a1a", border: "1px solid #333", borderRadius: 999, padding: "6px 14px", marginBottom: 16, width: "fit-content" };
const heroTitle: React.CSSProperties = { fontSize: "clamp(26px, 4vw, 38px)", fontWeight: 800, lineHeight: 1.2, margin: 0 };
const heroDesc: React.CSSProperties = { color: "#999", marginTop: 12, lineHeight: 1.7, fontSize: 15 };
const ctaBtn: React.CSSProperties = { display: "inline-flex", alignItems: "center", gap: 8, background: "#FFD700", color: "#000", padding: "12px 22px", borderRadius: 10, textDecoration: "none", fontWeight: 700, fontSize: 14 };
const section: React.CSSProperties = { padding: "60px 20px" };
const sectionAlt: React.CSSProperties = { padding: "60px 20px", background: "#0e0e0e" };
const container: React.CSSProperties = { maxWidth: 1100, margin: "0 auto" };
const sectionLabel: React.CSSProperties = { fontSize: 12, fontWeight: 700, letterSpacing: 2, textTransform: "uppercase", color: "#FFD700", display: "block", marginBottom: 8 };
const title: React.CSSProperties = { fontSize: "clamp(20px, 3.5vw, 26px)", fontWeight: 800, marginBottom: 24, marginTop: 4 };
const statsGrid: React.CSSProperties = { display: "grid", gap: 16  };
const featureGrid: React.CSSProperties = { display: "grid", gap: 16  };
const processGrid: React.CSSProperties = { display: "grid", gap: 16 };
const map: React.CSSProperties = { width: "100%", height: 280, border: 0, borderRadius: 14, filter: "grayscale(20%)" };
const contactChip: React.CSSProperties = { display: "inline-flex", alignItems: "center", gap: 8, padding: "10px 18px", borderRadius: 10, border: "1.5px solid #FFD700", color: "#FFD700", textDecoration: "none", fontSize: 14, fontWeight: 600 };
const ctaSection: React.CSSProperties = { textAlign: "center", padding: "70px 20px", background: "linear-gradient(180deg, #0a0a0a 0%, #111 100%)" };
const btnPrimary: React.CSSProperties = { display: "inline-flex", alignItems: "center", gap: 8, background: "#FFD700", color: "#000", padding: "13px 26px", borderRadius: 10, textDecoration: "none", fontWeight: 700, fontSize: 15 };